import {REPORT_CLOSE_TO_SENIOR_COACH_RANK} from '/enum/records.enum';

export default {
  reportName: REPORT_CLOSE_TO_SENIOR_COACH_RANK,
};
